import { Injectable } from '@angular/core';
import {
  MyHttpClientFactory,
  ResponseCasingEnum,
  LocalStorageService,
  environment,
} from '@ups/xplat/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs';
import { ProfileModel } from '@ups/xplat/api/dto';

const FAVORITE_JOB = '/api/jobs/favorite';

@Injectable({
  providedIn: 'root',
})
export class SearchJobService {
  private http: HttpClient;
  private profile: ProfileModel;

  constructor(
    private clientFactory: MyHttpClientFactory,
    private storage: LocalStorageService
  ) {
    this.http = this.clientFactory.createHttpClient(
      environment.urls.spartaAPI,
      true,
      ResponseCasingEnum.PascalCase
    );
    this.profile = this.storage.getItem('profile') as ProfileModel;
  }

  // #31495: request up to 100 (server caps at 100) so a foreman with 50+ jobs can find and add
  // any of them from the search. The server floors take at 30, so this never returns fewer than before.
  search(searchString: string, params: HttpParams = null, limit: number = 100) {
    params = params || new HttpParams();
    params = params.append('searchString', searchString);
    params = params.append('take', limit);
    return this.http
      .get(`/api/jobs/dropdown`, {
        params,
      })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  public addOrRemoveFavoriteJob(jobID: string, auth0UserId?: string) {
    const url = FAVORITE_JOB;
    return this.http
      .post(url, {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        UserID: auth0UserId ? auth0UserId : this.profile.auth0UserId,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        JobID: jobID,
      })
      .toPromise();
  }
}
